import { Injectable } from '@angular/core';
import { Query } from '@datorama/akita';
import { SettingsStore, SettingsState } from './settings.store';

@Injectable({ providedIn: 'root' })
export class SettingsQuery extends Query<SettingsState> {

    get settingsLoaded(): boolean {
        return this.getValue().settingsLoaded;
    }

    get traceabilityIsActive(): boolean {
        return this.getValue().traceabilityIsActive;
    }

    constructor(protected store: SettingsStore) {
        super(store);
    }

}
